export interface Tomo {
  id: string
  tab: string
  tabSubtitle: string
  title: string
  intro: string
  chapters: string[]
  pages: string
  readingTime: string
  image: string
  imageAlt: string
  isCover?: boolean
}

export const tomos: Tomo[] = [
  {
    id: 'tomo-1',
    tab: 'Tomo 1',
    tabSubtitle: 'Anatomía aeronáutica y sistemas críticos',
    title: 'La ingeniería detrás de tu dron',
    intro:
      'Antes de volar, necesitas entender por qué vuela. De la física básica a la IMU, los ESC, las baterías LiPo y los motores brushless, explicado para que puedas diagnosticar problemas y exprimir la autonomía real.',
    chapters: [
      'Las fuerzas que hacen volar un dron: sustentación, peso, empuje y drag',
      'Cómo funciona cada componente: motor, ESC, IMU, compass',
      'Física de baterías LiPo: por qué se hinchan y cómo alargarles la vida',
      'Aerodinámica aplicada: por qué el viento destruye la autonomía',
      'Troubleshooting: qué hacer cuando algo falla en vuelo',
    ],
    pages: '60 páginas',
    readingTime: '6 – 8 horas de lectura',
    image:
      'https://cdn.magicpatterns.com/uploads/dHmUbAGygt4uAYA5zCeFW8/ChatGPT_Image_16_sept_2026,_05_26_32_p.m..png',
    imageAlt:
      'Portada del Tomo 1: Anatomía Aeronáutica y Sistemas Críticos, con un dron en vista despiezada',
    isCover: true,
  },
  {
    id: 'tomo-2',
    tab: 'Tomo 2',
    tabSubtitle: 'Meteorología, espacio aéreo y navegación',
    title: 'El clima y las reglas del cielo',
    intro:
      'El aire no es amigable. Aprende a leer el viento, la presión barométrica y el índice Kp solar, y a moverte por las “carreteras invisibles” del espacio aéreo que definen dónde puedes volar legalmente.',
    chapters: [
      'Viento, ráfagas y wind shear: cómo arruinan tu vuelo',
      'Presión barométrica: por qué la altitud reduce autonomía',
      'Índice Kp solar: cómo afecta tu GPS en tiempo real',
      'Clases de espacio aéreo: dónde SÍ puedes volar legalmente',
      'Lectura de mapas meteorológicos profesionales',
    ],
    pages: '70 páginas',
    readingTime: '8 – 10 horas de lectura',
    image:
      'https://cdn.magicpatterns.com/uploads/pAt2w76atBuMzctRGvAKtA/ChatGPT_Image_16_sept_2026,_05_27_03_p.m..png',
    imageAlt:
      'Portada del Tomo 2: Meteorología, Espacio Aéreo y Navegación, con un dron frente a una tormenta',
    isCover: true,
  },
  {
    id: 'tomo-3',
    tab: 'Tomo 3',
    tabSubtitle: 'Salida laboral, sectores y negocio',
    title: 'De hobby a ingresos reales',
    intro:
      'Los 5 sectores que realmente pagan en 2026: agricultura (USD 150–300 por mapeo), construcción (USD 400–600), inspección industrial (USD 500–2,000), minería (USD 1,500–5,000) y vigilancia (USD 500–1,000).',
    chapters: [
      'Los 5 sectores que pagan dinero real en LATAM',
      'Precios exactos por país y tipo de operación',
      'Estructura de costos: no perder dinero en operaciones',
      'Contratos profesionales: cómo protegerte legalmente',
      'Seguros y responsabilidad civil: qué necesitas realmente',
      'Escalabilidad: de piloto solista a operador con equipo',
    ],
    pages: '75 páginas',
    readingTime: '10 – 12 horas de lectura',
    image:
      'https://cdn.magicpatterns.com/uploads/sMHwntRxBgz9fF8K9VJH1c/ChatGPT_Image_16_sept_2026,_05_27_13_p.m..png',
    imageAlt:
      'Portada del Tomo 3: Salida Laboral, Sectores y Modelo de Negocio, con un operador de dron en campo',
    isCover: true,
  },
  {
    id: 'tomo-4',
    tab: 'Tomo 4',
    tabSubtitle: 'Certificación y examen oficial',
    title: 'Tu licencia oficial en LATAM',
    intro:
      'Sin certificación oficial no puedes operar comercialmente. Este tomo es el simulacro completo antes de presentarte ante la autoridad de tu país, con análisis de requisitos, costos y multas por país.',
    chapters: [
      'Banco de 150+ preguntas tipo examen real',
      '5 casos de estudio: decisiones difíciles en operaciones reales',
      'Simulacro completo de 50 preguntas bajo presión',
      'Errores comunes que causan el 40% de rechazo',
      'Planes de estudio express (7 días) y profesional (14 días)',
      'Técnicas de memorización y preparación psicológica',
    ],
    pages: '80 páginas',
    readingTime: '12 – 15 horas (incluye práctica)',
    image:
      'https://cdn.magicpatterns.com/uploads/fuMipyWnpaKgcuuoJNMWDH/ChatGPT_Image_16_sept_2026,_05_08_20_p.m..png',
    imageAlt:
      'Portada del Tomo 4: Preparación para Certificación y Simulacros de Examen, con licencia de piloto y hoja de respuestas',
    isCover: true,
  },
]
